import React, { memo } from 'react'
import PropTypes from 'prop-types'

import Header from '@components/layout/header'

import { Icon, IconBox } from './loader-style'

const Loader = ({ isLoading, children }) => {
  return (
    <>
      {isLoading ? (
        <>
          <Header />
          <IconBox>
            <Icon className="fa fa-spinner fa-spin" />
          </IconBox>
        </>
      ) : (
        children
      )}
    </>
  )
}

Loader.displayName = 'CompanyStep_Page'

Loader.propTypes = {
  isLoading: PropTypes.bool,
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
}

export default memo(Loader)
